<div class="py-4 px-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>{{ "userMaterials.title" | translate }}</h1>
      </div>

      <div class="col-auto">
        <a class="btn btn-link text-blue" [routerLink]="['/lisaa-oppimateriaali', 1]">
          {{ "userMaterials.createNew" | translate }}
        </a>
      </div>
    </div>

    @if (unpublishedMaterials?.length > 0) {
      <div class="row mb-3">
        <div class="col-12">
          <h2>{{ "userMaterials.unpublished.title" | translate }}</h2>
        </div>
        @for (material of unpublishedMaterials; track material) {
          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card-educational-material unpublished">
              @if (material.name) {
                <h3>{{ material.name[lang] }}</h3>
              } @else {
                <h3>{{ "userMaterials.unpublished.unnamed" | translate }} #{{ material.id }}</h3>
              }
            </div>
            <a [routerLink]="['/muokkaa-oppimateriaalia', material.id, 1]" class="btn btn-blue w-100">
              {{ "userMaterials.edit" | translate }}
            </a>
          </div>
        }
      </div>
    }

    @if (publishedMaterials?.length > 0) {
      <div class="row mb-3">
        <div class="col-12">
          <h2>{{ "userMaterials.published.title" | translate }}</h2>
        </div>
        @for (material of publishedMaterials; track material) {
          <div class="col-md-6 col-lg-4 mb-3">
            @if (material.expires) {
              <alert [type]="expireAlertType(material.expires)">
                @switch (expireAlertType(material.expires)) {
                  @case ('expired') {
                    {{ "userMaterials.expired" | translate: { date: material.expires | date: "d.M.yyyy" } }}
                  }
                  @default {
                    {{ "userMaterials.expires" | translate: { date: material.expires | date: "d.M.yyyy" } }}
                  }
                }
              </alert>
            }
            <app-educational-material-card [educationalMaterial]="material"></app-educational-material-card>
            <a [routerLink]="['/muokkaa-oppimateriaalia', material.id, 1]" class="btn btn-blue w-100">
              {{ "userMaterials.edit" | translate }}
            </a>
          </div>
        }
      </div>
    } @else {
      <p>{{ "userMaterials.noMaterials" | translate }}</p>
    }


    @if (privateCollections && privateCollections.length > 0) {
      <div class="row mb-3">
        <div class="col-12">
          <h2>{{ "userCollections.private.title" | translate }}</h2>
        </div>
        @for (collection of privateCollections; track collection) {
          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card-educational-material private">
              <a [routerLink]="['/kokoelma', collection.id]">
                <div class="row g-0">
                  <div
                    class="col-sm-4 col-md-12 col-lg-5 text-center text-sm-start text-md-center text-lg-start mb-3 mb-lg-0">
                    <img
                      [src]="collection.thumbnail ? collection.thumbnail : 'assets/img/thumbnails/kokoelma.png'"
                      class="img-fluid"
                      [alt]="'demo.educationalMaterial.cover.alt' | translate" />
                  </div>
                  <div class="col-sm-8 col-md-12 col-lg-7 px-sm-3">
                    <h3>{{ collection.name }}</h3>
                  </div>
                </div>
              </a>
            </div>
            <a [routerLink]="['/kokoelma', collection.id, 'muokkaa']" class="btn btn-blue w-100">
              {{ "userMaterials.edit" | translate }}
            </a>
          </div>
        }
      </div>
    }

    @if (publicCollections && publicCollections.length > 0) {
      <div class="row mb-3">
        <div class="col-12">
          <h2>{{ "userCollections.published.title" | translate }}</h2>
        </div>
        <!--<a [routerLink]="['/kokoelma', collection.id]"></a>-->
        @for (collection of publicCollections; track collection) {
          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card-educational-material">
              <a [routerLink]="['/kokoelma', collection.id]">
                <div class="row g-0">
                  <div
                    class="col-sm-4 col-md-12 col-lg-5 text-center text-sm-start text-md-center text-lg-start mb-3 mb-lg-0">
                    <img
                      [src]="collection.thumbnail ? collection.thumbnail : 'assets/img/thumbnails/kokoelma.png'"
                      class="img-fluid"
                      [alt]="'demo.educationalMaterial.cover.alt' | translate" />
                  </div>
                  <div class="col-sm-8 col-md-12 col-lg-7 px-sm-3">
                    <h3>{{ collection.name }}</h3>
                  </div>
                </div>
              </a>
            </div>
            <a [routerLink]="['/kokoelma', collection.id, 'muokkaa']" class="btn btn-blue w-100">
              {{ "userMaterials.edit" | translate }}
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>
